<template>

    <v-row row>
        <v-col cols="12">
            <v-card flat>
                <v-list two-line>
                    <v-list-item>

                        <v-list-item-avatar>
                            <avatar :image-url="project.created_by.photo_url" :person-name="project.created_by.name"></avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title v-html="project.created_by.name"></v-list-item-title>
                            <v-list-item-subtitle>Respected project owner</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>

                        <v-list-item-avatar>
                            <v-icon>mdi-calendar</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ toLocalDateTime(project.start_date) }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Project start time ({{ toHumanTill(project.start_date) }})
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>

                        <v-list-item-avatar>
                            <v-icon>mdi-clock</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ toLocalDateTime(project.end_date) }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Project dead line ({{ toHumanTill(project.end_date) }})
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>

                <v-btn color="primary" @click="editProject(project)">Edit project</v-btn>
            </v-card>
        </v-col>

        <json v-if="debug" :data="project"></json>

    </v-row>

</template>

<script>


    import Json from 'vue-json-pretty';
    import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
    import Avatar from '../../../components/UI/Avatar';

    export default {

        mixins: [timeDisplay],

        components: {
            Json,
            Avatar
        },

        props: {
            project: {
                type: Object,
                required: true,
            }
        },

        methods: {
            editProject(project) {
                this.$emit('edit', project);
            }
        },

        data() {
            return {
                debug: false,
            }
        }
    }
</script>
